import useSWR from 'swr';
import { removeHost } from '@packages/shared';
import { useContext } from 'react';
import { useConfig } from '@packages/utilities';

import { SEARCH_FILTER_URL } from '../api/rest/endpoints';
import type { SearchFilterApiRequestOptions } from '../api/rest/types';
import { searchFilterFetcher } from '../api/rest/fetchers';
import { SearchApiRequestContext } from '../SearchApiRequestContext';

/**
 * This hook returns the values for a filter group
 */
export const useFilterGroupValues = (filterId: string, shouldFetch: boolean = true) => {
  const { clientId } = useConfig();
  const { requestCacheKey } = useContext(SearchApiRequestContext);

  const options: SearchFilterApiRequestOptions = {
    requestCacheKey,
    filterName: filterId,
    clientId,
  };

  const { data, isLoading, error } = useSWR(
    shouldFetch ? [removeHost(SEARCH_FILTER_URL), options] : null,
    searchFilterFetcher,
    {
      suspense: true,
    },
  );

  return {
    response: data,
    isLoading,
    error,
  };
};
